import React from "react";
import SubText from "./SubText";
import SubImg from "./SubImg";

function TextPic({ title, content, img, width = "100%" }) {
  return (
    <div>
      <div
        className="container my-5"
        style={{ backgroundColor: "#EDEEF0", padding: "30px" }}
      >
        <div className="row">
          <SubText title={title} content={content} />
          <SubImg img={img} width={width} />
        </div>
      </div>
    </div>
  );
}

export default TextPic;
